import React from 'react';
import { Reveal } from './Reveal';
export function FaqSection() {
  return <section className="py-14 px-6" data-id="element-60">
      <Reveal data-id="element-61">
        <span className="inline-block text-[10px] font-semibold tracking-[0.14em] uppercase text-sage mb-3" data-id="element-62">
          Preguntas frecuentes
        </span>
        <h2 className="font-serif text-[34px] font-semibold leading-[1.15] text-ink mb-6" data-id="element-63">
          Antes de
          <br data-id="element-64" />
          <em className="italic text-terra" data-id="element-65">comprar</em>
        </h2>

        <div className="flex flex-col" data-id="element-66">
          <div className="border-b border-cream-dark py-4.5" data-id="element-67">
            <p className="text-[14px] font-semibold text-ink mb-2 leading-[1.4]" data-id="element-68">
              ¿Necesito tener conocimientos médicos?
            </p>
            <p className="text-[13px] text-ink-soft leading-[1.6]" data-id="element-69">
              No. La guía está escrita en español claro, sin tecnicismos.
              Cualquier término médico se explica en la misma oración.
            </p>
          </div>
          <div className="border-b border-cream-dark py-4.5" data-id="element-70">
            <p className="text-[14px] font-semibold text-ink mb-2 leading-[1.4]" data-id="element-71">
              ¿Cuándo recibo la guía?
            </p>
            <p className="text-[13px] text-ink-soft leading-[1.6]" data-id="element-72">
              Inmediatamente después del pago. Recibís el acceso por email en
              minutos.
            </p>
          </div>
          <div className="border-b border-cream-dark py-4.5" data-id="element-73">
            <p className="text-[14px] font-semibold text-ink mb-2 leading-[1.4]" data-id="element-74">
              ¿Es una consulta médica?
            </p>
            <p className="text-[13px] text-ink-soft leading-[1.6]" data-id="element-75">
              No. Es información educativa basada en evidencia científica
              actual. No reemplaza la consulta con tu profesional de salud — la
              complementa.
            </p>
          </div>
          <div className="border-b border-cream-dark py-4.5" data-id="element-76">
            <p className="text-[14px] font-semibold text-ink mb-2 leading-[1.4]" data-id="element-77">
              ¿Qué es el test de perfil hormonal?
            </p>
            <p className="text-[13px] text-ink-soft leading-[1.6]" data-id="element-78">
              Es una herramienta interactiva incluida gratis. 12 preguntas sobre
              tus síntomas que identifican tu perfil hormonal predominante y te
              dicen exactamente qué leer primero.
            </p>
          </div>
          <div className="border-b border-cream-dark py-4.5" data-id="element-79">
            <p className="text-[14px] font-semibold text-ink mb-2 leading-[1.4]" data-id="element-80">
              ¿Funciona si no tengo diagnóstico?
            </p>
            <p className="text-[13px] text-ink-soft leading-[1.6]" data-id="element-81">
              Sí. La mayoría de las lectoras no tienen diagnóstico. La guía
              ayuda a entender los síntomas y a hacer mejores preguntas en la
              próxima consulta médica.
            </p>
          </div>
        </div>
      </Reveal>
    </section>;
}